import { isEmptyObject } from "../../../utils/tests";
import { TeamCalendarAndResultsQuery } from '../types';

/**
 * typeguard for TeamCalendarAndResultsQuery
 * @param TeamCalendarAndResultsQuery object passed to transformer
 */
export const isValidTeamCalendarAndResults = (obj: TeamCalendarAndResultsQuery): boolean => Boolean(obj?.data?.teamCalendarAndResults && !isEmptyObject(obj.data.teamCalendarAndResults));
